<template>
  <div>
    <Header :projectHeaderData="projects[index].headerComponent" :index="Number(index)" :size="Number(projects.length)"></Header>
    <Description :projectDescriptionData="projects[index].descriptionComponent"></Description>
    <u-x-description :projectUxData="projects[index].uxDesign" v-if="index != '1' && index != '6' && index != '11' "></u-x-description>
    <u-i-description :projectUiData="projects[index].uiDesign" v-if="index != '1' && index != '5' && index != '11'"></u-i-description>
    <UXUIDesignWide :projectUXUIDesignWideData="projects[index].uxUiDesignWide" v-if="index === '1' || index === '5'"></UXUIDesignWide>
    <Icons :projectIconsData="projects[index].icons" v-if="index === '3' && window.innerWidth > 600"></Icons>
    <UIDesignWide :projectUIDesignWideData="projects[index].uiDesignWide" v-if="index === '11'"></UIDesignWide>
    <Footer :projectFooterData="projects[index].footer" :index="Number(index)" :size="Number(projects.length)"></Footer>
  </div>
</template>
<script>
  import CustomerHeader from './CustomerHeader'
  import CustomerDescription from './CustomerDescription'
  import CustomerUXDescription from './CustomerUXDesign.vue'
  import CustomerUIDescription from './CustomerUIDesign'
  import CustomerUXUIDesignWide from './CustomerUXUIDesignWide'
  import CustomerIcons from './CustomerIcons'
  import CustomerFooter from './CustomerFooter'
  import CustomerUIDesignWide from './CustomerUIDesignWide'

  export default {
    data() {
      return {
        projects: window.projectsData,
        index: this.$route.params.id,
        window
      }
    },
    created() {
      //console.log(this.index);
    },
    components: {
      Header: CustomerHeader,
      Description: CustomerDescription,
      UXDescription: CustomerUXDescription,
      UIDescription: CustomerUIDescription,
      UXUIDesignWide: CustomerUXUIDesignWide,
      Icons: CustomerIcons,
      UIDesignWide: CustomerUIDesignWide,
      Footer: CustomerFooter
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/CustomersComponents/CustomerMain.vue